'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import NextImage from 'next/image';
import PropTypes from 'prop-types';

import ButtonCircle from 'components/ui/ButtonCircle';
import EntryLink from 'components/ui/Link/EntryLink';
import Text from 'components/ui/Text';

import { useTheme } from 'hooks/useTheme';
import { getColor } from 'utils';
import { addProtocol } from 'utils/url';

import styles from './CardCampaign.module.scss';

const CardCampaign = ({
    headline,
    description,
    image,
    bgColor,
    color,
    chevronTheme,
    link,
}) => {
    const [globalTheme] = useTheme();

    bgColor ??= 'orange';
    color ??= 'cream';
    chevronTheme ??= 'cream';

    return (
        <EntryLink entry={link}>
            <article
                className={styles.campaign}
                style={{
                    backgroundColor: getColor(bgColor),
                    color: getColor(color),
                }}
            >
                <div className={styles.imageContainer}>
                    {image && image.url && (
                        <NextImage
                            className={styles.image}
                            src={addProtocol(image.url)}
                            width={image.width}
                            height={image.height}
                            sizes="(max-width: 768px) 50vw, 20vw"
                            alt={image.description || ''}
                        />
                    )}
                </div>
                <Text
                    baseTheme="displayXSmall"
                    themes={{ large: 'displaySmall' }}
                    className={styles.headline}
                >
                    {headline}
                </Text>
                <Text
                    className={styles.description}
                    baseTheme="bodyMedium"
                    themes={{ xLarge: 'bodyLarge' }}
                >
                    {description}
                </Text>
                <ButtonCircle
                    as="span"
                    aria-hidden="true"
                    theme={
                        globalTheme === 'makers-reserve'
                            ? 'small-fill-makers-brown'
                            : chevronTheme === 'cream'
                              ? 'small-fill-creamdark'
                              : 'small-fill-blue'
                    }
                    iconType="chevronRight"
                >
                    <span />
                </ButtonCircle>
            </article>
        </EntryLink>
    );
};

CardCampaign.propTypes = {
    headline: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.shape({
        description: PropTypes.string,
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        url: PropTypes.string.isRequired,
    }).isRequired,
    link: PropTypes.object.isRequired,
    bgColor: PropTypes.string,
    color: PropTypes.string,
    chevronTheme: PropTypes.oneOf(['cream', 'blue', 'brown']),
};

export default CardCampaign;
